import { GradientButton } from './gradient-button'

export const BlueGradientButton = (props: IGradientButton) => (
  <GradientButton gradient="blue" {...props} />
)
